import * as z from "zod";

export const exportPoshmarkListingsCsv = {
  name: "exportPoshmarkListingsCsv" as const,
  input: z.object({
    startDate: z.date().optional(),
    endDate: z.date().optional(),
  }),
  output: z.object({ csv: z.string() }),
};
